import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { Modal, Form, Button } from "react-bootstrap";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
const currencies = [
    {
        value: "1",
        label: "1 Days",
    },
    {
        value: "3",
        label: "3 Days",
    },
    {
        value: "7",
        label: "7 Days",
    },
    {
        value: "14",
        label: "14 Days",
    },
    {
        value: "30",
        label: "30 Days",
    },
    // {
    //   value: "90",
    //   label: "90 Days(3 Months)",
    // },
    // {
    //   value: "180",
    //   label: "180 Days(6 Months)",
    // },
    // {
    //   value: "364",
    //   label: "364 Days(1 Year)",
    // },
];

const label = { inputProps: { "aria-label": "Switch demo" } };
const RGLimitDialogRaw = (props) => {
    const {
        onClose,
        //  value: valueProp,

        updateBet,
        updateDeposit,
        open,
        userObject,
        coolOffUser,
        excludeUser,

        ...other
    } = props;
    const [selectBetLimit, setSelectBetLimit] = useState("")
    const [selectDepositLimit, setSelectDepositLimit] = useState("")
    const [days, setDays] = React.useState('7');
    const [amount, setAmount] = useState(0)
    const [days1, setDays1] = React.useState('7');
    const [amount1, setAmount1] = useState(0)

    const [coolDay, setCoolDay] = React.useState('7');
    const [resetDate, setResetDate] = useState("")
    const [resetDepositDate, setResetDepositDate] = useState("")

    const [betObj, setBetObj] = useState({})
    const [depositObj, setDepositBetObj] = useState({})
    const handleCancel = () => {
        onClose();
    };
    useEffect(() => {
        let FilterBetLimit = userObject?.rg_LimitsDto?.filter((item) => item.rg_type == "1");
        let FilterDepositLimit = userObject?.rg_LimitsDto?.filter((item) => item.rg_type == "2")
        // console.log('FilterBetLimit', FilterBetLimit);
        // console.log('FilterDepositLimit', FilterDepositLimit)
        FilterBetLimit && setBetObj(FilterBetLimit[0]);
        FilterDepositLimit && setDepositBetObj(FilterDepositLimit[0])

        FilterBetLimit && setDays(FilterBetLimit[0]?.time_period)
        FilterBetLimit && setAmount(FilterBetLimit[0]?.rg_limit_value);
        FilterBetLimit && setSelectBetLimit(FilterBetLimit[0]?.isActive);
        FilterBetLimit && setResetDate(moment(FilterBetLimit[0]?.reset_date).format('Do MMM YY'))

        FilterDepositLimit && setDays1(FilterDepositLimit[0]?.time_period);
        FilterDepositLimit && setAmount1(FilterDepositLimit[0]?.rg_limit_value);
        FilterDepositLimit && setSelectDepositLimit(FilterDepositLimit[0]?.isActive)
        FilterDepositLimit && setResetDepositDate(moment(FilterDepositLimit[0]?.reset_date).format('Do MMM YY'))


    }, [userObject?.rg_LimitsDto, open])

    const handleOk = () => {
        onClose();
    };
    const handleBet = () => {
        let data = {
            id_user: userObject.idUser,
            rg_type: 1,
            rg_limit_value: parseInt(amount),
            time_period: parseInt(days),
            isActive: selectBetLimit
        }

        updateBet(data)
    }
    const handleDeposit = () => {
        let data = {
            id_user: userObject.idUser,
            rg_type: 2,
            rg_limit_value: parseInt(amount1),
            time_period: parseInt(days1),
            isActive: selectDepositLimit
        }
        updateDeposit(data)
    }
    const handleExclude = () => {
        let data = {
            id_user: userObject.idUser,
            isActive: true
        }

        excludeUser(data)
    }
    const handleCoolOff = () => {
        let data = {
            id_user: userObject.idUser,
            time_period: parseInt(coolDay),
            isActive: true
        }
        coolOffUser(data)
    }

    const handleChange = (event) => {
        setDays(event.target.value);
    };
    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    }
    const handleChange1 = (event) => {
        setDays1(event.target.value);
    };
    const handleChange2 = (event) => {
        setCoolDay(event.target.value);
    };

    const handleAmountChange1 = (event) => {
        setAmount1(event.target.value);
    }
    return (
        <Dialog
            sx={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 650 } }}
            maxWidth="md"
            // TransitionProps={{ onEntering: handleEntering }}
            open={open}
            {...other}
        >
            <DialogTitle>RG Limit </DialogTitle>
            <DialogContent dividers>
                <p className="darkgray s-size f-bold">Bet Limits</p>
                <div className="modal-div-limit border-only">
                    <div className="row align-items-center">
                        <div className="col-md-2">
                            <Switch {...label}
                                // disabled={selectDepositLimit} 
                                name="bet Limit"
                                value={selectBetLimit} onClick={() => {
                                    setSelectBetLimit(!selectBetLimit)
                                }}
                                size="medium"
                                color="success"
                                checked={selectBetLimit}
                            />
                        </div>
                        <div className="col-md-3">
                            <Box
                                component="form"
                                sx={{
                                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div>
                                    <TextField
                                        id="outlined-select-currency"
                                        select
                                        label="Period (Days)"
                                        defaultValue="7 Days"
                                        value={days}
                                        onChange={handleChange}
                                    >
                                        {currencies.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                            </Box>
                        </div>
                        <div className="col-md-3">
                            <Box
                                component="form"
                                sx={{
                                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div>
                                    <TextField
                                        id="outlined-error"
                                        label="Amount"
                                        value={amount}
                                        onChange={handleAmountChange}
                                    />

                                    {/* <FormControl fullWidth sx={{ m: 1 }}  onChange={handleAmountChange}  value={amount} >
          <InputLabel htmlFor="outlined-adornment-amount"     value={amount} 
                   >Amount</InputLabel>
          <OutlinedInput
            id="outlined-adornment-amount"
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
            label="Amount"
          />
        </FormControl> */}
                                </div>
                            </Box>
                        </div>
                        <div className="col-md-4">
                            <div >
                                {/* <button className="btn btn-secondary btn-sm w-50" onClick={handleBet}>
                Update
                </button> */}
                                <Button variant="light" onClick={handleBet} style={{ border: '3px solid green', width: '100%' }}>Update</Button>
                                <span style={{ fontSize: '12px' }}>Update will be applied on {resetDate}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="darkgray s-size mt-3 mb-1 f-bold">Deposit Limits</p>
                <div className="modal-div-limit border-only">
                    <div className="row align-items-center">
                        <div className="col-md-2">
                            <Switch {...label}
                                name="deposit Limit"
                                checked={selectDepositLimit}
                                color="success"
                                //  disabled={selectBetLimit}
                                value={selectDepositLimit} onClick={() => {
                                    setSelectDepositLimit(!selectDepositLimit)
                                }} />
                        </div>
                        <div className="col-md-3">
                            <Box
                                component="form"
                                sx={{
                                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div>
                                    <TextField
                                        id="outlined-select-currency"
                                        select
                                        label="Period (Days)"
                                        value={days1}
                                        onChange={handleChange1}
                                    >
                                        {currencies.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                            </Box>
                        </div>
                        <div className="col-md-3">
                            <Box
                                component="form"
                                sx={{
                                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div>
                                    <TextField
                                        id="outlined-error"
                                        label="Amount"
                                        value={amount1}
                                        onChange={handleAmountChange1}
                                    />
                                </div>
                                {/* <FormControl fullWidth sx={{ m: 1 }}    value={amount1} 
                    onChange={handleAmountChange1}>
          <InputLabel htmlFor="outlined-adornment-amount"     value={amount1} 
                   >Amount</InputLabel>
          <OutlinedInput
            id="outlined-adornment-amount"
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
            label="Amount"
          />
        </FormControl> */}
                            </Box>
                        </div>
                        <div className="col-md-4">
                            <div >
                                {/* <button className="btn btn-secondary btn-sm w-50" onClick={handleDeposit}>
                  Update
                </button> */}
                                <Button variant="light" onClick={handleDeposit} style={{ border: '3px solid green', width: '100%' }}>Update</Button>
                                <span style={{ fontSize: '12px' }}>Update will be applied on {resetDepositDate}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-6">

                        <p className="darkgray s-size mt-3 mb-1 f-bold"> Cool off Period:</p>
                        <div className="modal-div-limit border-only" style={{ border: '1px solid orange' }}>
                            <div className="row">
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <Box
                                            component="form"
                                            sx={{
                                                "& .MuiTextField-root": { m: 1, width: "25ch" },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <div>
                                                <TextField
                                                    id="outlined-select-currency"
                                                    select
                                                    label="Period (Days)"
                                                    defaultValue="7 Days"
                                                    value={coolDay}
                                                    onChange={handleChange2}

                                                >
                                                    {currencies.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="text-center">
                                            {/* <button className="btn btn-secondary btn-sm w-50">
                        Apply
                      </button> */}
                                            <Button variant="light" style={{ border: '3px solid orange', width: '100%' }} onClick={handleCoolOff}>Apply</Button>
                                        </div>

                                    </div>
                                    <p className="darkgray s-size">
                                        Update will be applied Immediately. You will not be able to Deposit or Bet during the cool off period.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <p className="darkgray s-size mt-3 mb-1 f-bold">Self Exclusion</p>
                        <div className="modal-div-limit" style={{ border: '1px solid red', padding: '5px' }}>
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <Button variant="light" style={{ border: '2px solid red', width: '50%' }} onClick={handleExclude}>Self Exclude</Button>
                                    </div>
                                    <p className="darkgray s-size" style={{ marginBottom: '2px', textAlign: 'center' }}>
                                        This will be applied Immediately
                                        You will no longer be able to access your account
                                    </p>
                                    <p style={{ color: 'red', fontWeight: '600', marginBottom: '0px', fontSize: '13px', textAlign: 'center' }}>This process is non reversible</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default RGLimitDialogRaw